<template>
  <section class="nyd-footer">
    <div class="links">
      <div class="container">
        <div class="firend-list">
          <!-- <a :href="item.article_url" target="_blank" v-for="item in firends" :key="item.id">{{ item.article_title }}</a> -->
        </div>
        <ul class="link-list">
          <li :style="'background-image: url(' + links[0] + ')'"><!-- <img :src="" /> --></li>
          <li :style="'background-image: url(' + links[1] + ')'"></li>
          <li :style="'background-image: url(' + links[2] + ')'">
            <div class="wechat"><img :src="qrCode"></div>
            <!-- <img :src="links[2]" /> -->
          </li>
        </ul>
      </div>
    </div>
    <section class="interconnection">
      <lm-container :width="1500">
        <div class="list">
          <a class="item" v-for="item in [
            {
              school: 'Study in China',
              link: 'https://www.campuschina.org/'
            },
            {
              school: 'China Education Association for International Exchange',
              link: 'https://en.ceaie.edu.cn/'
            },
            {
              school: 'Chinese Tests Service Website',
              link: 'https://www.chinesetest.cn/'
            },
            {
              school: 'Academy for International Business Offcials(AIBO),Ministry of Commerce,People\'s Republic of China',
              link: 'https://www.china-aibo.cn/en/'
            }
          ]" :href="item.link" target="_blank">
            <div class="school">{{ item.school }}</div>
            <div class="name">{{ item.name }}</div>
          </a>
        </div>
        <lm-row :md-gutter="35">
          <!-- <lm-col :md-span="4">
            <div class="title">SCHOOLS</div>
            <ul class="list">
              <li class="text" v-for="item in ['Business', 'Education', 'Engineering', 'Humanities & Sciences', 'Law', 'Medicine', 'Sustainability']">{{ item }}</li>
            </ul>
          </lm-col>
          <lm-col :md-span="4">
            <div class="title">DEPARTMENTS</div>
            <ul class="list">
              <li class="text" v-for="item in ['Departments A -to Z', 'Interdisciplinary Programs']">{{ item }}</li>
            </ul>
            <div class="title">RESEARCH</div>
            <ul class="list">
              <li class="text" v-for="item in ['Research Centers A -to Z', 'Interdisciplinary Research', 'Libraries']">{{ item }}</li>
            </ul>
          </lm-col>
          <lm-col :md-span="4">
            <div class="title">HEALTH CARE</div>
            <ul class="list">
              <li class="text" v-for="item in ['Health Care', `Children's Health`]">{{ item }}</li>
            </ul>
            <div class="title">ONLINE LEARNING</div>
            <ul class="list">
              <li class="text" v-for="item in ['Online']">{{ item }}</li>
            </ul>
          </lm-col>
          <lm-col :md-span="4">
            <div class="title">ABOUT</div>
            <ul class="list">
              <li class="text" v-for="item in ['Facts', 'History', 'Accreditation']">{{ item }}</li>
            </ul>
            <div class="title">ADMISSION</div>
            <ul class="list">
              <li class="text" v-for="item in ['Undergraduate', 'Graduate', 'Financial Aid']">{{ item }}</li>
            </ul>
          </lm-col>
          <lm-col :md-span="4">
            <div class="title">RESOURCES</div>
            <ul class="list">
              <li class="text" v-for="item in ['A -to Z Index', 'Campus Map', 'Community Engagement', 'Directory', 'Profiles']">{{ item }}</li>
            </ul>
          </lm-col>
          <lm-col :md-span="4">
            <ul>
              <li class="item" v-for="item in ['Applying', 'Visiting', 'Giving', 'Careers', 'Faculty Positions', 'Contact']">{{ item }}</li>
            </ul>
          </lm-col> -->
        </lm-row>
      </lm-container>
    </section>
    <footer>
      <div class="container" style="display: flex;">
        <div style="text-align: center; margin-right: 64px; font-weight: 600">
          <div style="font-size: 28px">Southern Medical</div>
          <div style="font-size: 28px">University</div>
        </div> 
        <address>
          <div style="display: flex; align-items: center;">
            <div style="font-size: 20px;font-weight: 600;">Address：</div>
            <span>School of International Education, Southern Medical University, 1023 Shatainan Road, Guangzhou,
              Guangdong Province, China;</span>
          </div>
          <div style="display: flex; align-items: center;">
            <div style="font-size: 20px;font-weight: 600;">Email：</div>
            <span>studysmu@smu.edu.cn</span>
          </div>
          <div>
            <span>
              Copyright &copy; Southern Medical University - School of International Education All rights reserved. 
            </span>
            
            
            
            <!-- Copyright&copyright;Southern Medical University - School of International Education All rights
              reserved. -->
          </div>
        </address>
      </div>
    </footer>
  </section>
</template>

<script>
import { frontFnMenu, frontArticles4Memu } from '@/api/api';

export default {
  data() {
    return {
      firends: [],
      links: [
        // require('@/assets/icons/facebook.png'),
        // require('@/assets/icons/bird.png'),
        require('@/assets/icons/phone.png'),
        require('@/assets/icons/video.png'),
        require('@/assets/icons/weixin.png'),
        // require('@/assets/icons/weixin.png'),
      ],
      qrCode: require('@/assets/imgs/pc_en_wechat_qrcode.png'),
    }
  },
  created() {
    this.getFirendLink();
  },
  methods: {
    getFirendLink() {
      // Other Module
      frontArticles4Memu({
        memu1Id: 'y0lmerqza8',
        memu2Id: 'y0lmeruadp'
      }).then(res => {
        console.log(res.data)
        this.firends = res.data.list;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';

.nyd-footer {
  position: relative;
  z-index: 99;
  .links {
    padding: 20px 0;
    background-color: #f4f4f4;

    .container {
      display: flex;
      justify-content: space-between;
      width: 1500px;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 0 12px;
      .firend-list {
        display: flex;
        align-items: center;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          padding: 0 8px;
          color: rgb(20, 89, 162);
          background-color: #b5cae0;
          cursor: pointer;
        }
      }
      .link-list {
        display: flex;
        align-items: center;
        position: relative;
        li {
          display: flex;
          align-items: center;
          margin-right: 18px;
          width: 28px;
          height: 28px;
          background-repeat: no-repeat;
          background-size: 100%;
          cursor: pointer;

          img {
            display: block;
            width: 100%;
            cursor: pointer;
          }

          .wechat {
            position: absolute;
            bottom: 28px;
            right: -36px;
            z-index: 1;
            width: 64px;
            height: 64px;
            opacity: 0;
            transition: opacity .48s ease-in-out;
          }

          &:hover .wechat {
            opacity: 1;
          }
        }
      }
    }
  }

  .interconnection {
    padding-top: 35px;
    // padding-bottom: 35px;
    background-color: #fff;
    .title {
      margin-bottom: 10.188px;
      font-size: 19px;
      font-weight: 500;
      color: $primaryColor; //rgb(130, 0, 0);
    }
    .text {
      margin-bottom: 15.2px;
      font-size: 1em;
      cursor: pointer;
      &:hover {
        color: $linkColor;
        text-decoration: underline;
      }
    }
    .list {
      margin-bottom: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .item {
      display: block;
      box-shadow: 0 0 10px rgba(0, 0, 0, .1),0 0 5px rgba(0, 0, 0, .1);
      margin-bottom: 20px;
      margin-right: 8px;
      border: 1px solid #aaa;
      padding: 4px 16px;
      line-height: 24px;
      text-align: center;
      cursor: pointer;
      &:hover {
        // border-color: rgb(140, 21, 21);
        // color: rgb(140, 21, 21);
        border-color: $primaryColor;
        color: $primaryColor;
      }
      .school {
        color: $primaryColor;
        font-size: 16px;
      }
      .name {
        font-size: 14px;
      }
    }
  }

  footer {
    // background-color: #8c1515; // 2
    background-color: #1459a2; // 3
    padding: 32px;
    color: #fff;

    .container {
      box-sizing: border-box;
      margin: 0 auto;
      width: 1436px;
    }

    address {
      font-style: normal;
    }

    p {
      padding-bottom: 16px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
</style>
